/*
 * Muori header behaviour.
 *
 * Two jobs, both of which need a measurement CSS cannot make:
 *
 * 1. The mega menu panel spans the full width, but its contents start under the
 *    trigger that opened it. The nav block is centred, so the trigger's x
 *    position depends on the viewport and has to be measured.
 * 2. On the home page the header sits transparently over the hero and turns
 *    solid once the hero has scrolled past (FUNCTIONAL-REQUIREMENTS.md 3.1).
 *    This half only runs when Dawn's own sticky header is off, so the two never
 *    contend for control of positioning.
 */
(() => {
  const header = document.querySelector('.header');
  if (!header) return;

  /* Align mega menu contents with the nav block. */

  const nav = header.querySelector('.header__inline-menu');

  const alignMegaMenu = () => {
    if (!nav) return;
    const left = nav.getBoundingClientRect().left - header.getBoundingClientRect().left;
    // Below the desktop breakpoint the nav is a drawer and the offset is meaningless.
    const applies = window.matchMedia('(min-width: 990px)').matches;
    header.style.setProperty('--muori-mega-inline-start', applies ? `${Math.round(left)}px` : 'auto');
  };

  /* Swap the home page header between overlaying the hero and sitting solid. */

  const wrapper = document.querySelector('.header-wrapper--muori-overlay');
  const PINNED = 'header-wrapper--muori-pinned';
  const hero = document.querySelector('#MainContent > .shopify-section');

  let observer;

  const watchHero = () => {
    if (!wrapper) return;

    // The stylesheet pulls the main content up by this much so the hero starts
    // underneath the bar. Publishing the measurement is what makes that possible.
    document.documentElement.style.setProperty(
      '--muori-header-height',
      `${Math.round(wrapper.getBoundingClientRect().height)}px`
    );

    // Without a hero to leave, the solid state is the only sensible one.
    if (!hero) {
      wrapper.classList.add(PINNED);
      return;
    }

    // An overlaying bar is taller than a pinned one, so re-measure rather than
    // caching a single height.
    const offset = Math.round(wrapper.getBoundingClientRect().height);

    if (observer) observer.disconnect();
    observer = new IntersectionObserver(
      ([entry]) => wrapper.classList.toggle(PINNED, !entry.isIntersecting),
      { rootMargin: `-${offset}px 0px 0px 0px`, threshold: 0 }
    );
    observer.observe(hero);
  };

  const refresh = () => {
    alignMegaMenu();
    watchHero();
  };

  refresh();

  let resizeTimer;
  window.addEventListener(
    'resize',
    () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 150);
    },
    { passive: true }
  );

  // The nav can reflow after webfonts land, which moves the trigger.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(alignMegaMenu);
  }
})();
